<template>
    <div class="flex items-center" v-if="this.code">
        <div class="mr-4">
            <a href="/qrcodes" class="link-primary">QR коды</a>
        </div>
        <div class="mr-4">
            <ArrowRightIcon class="h-5 w-5" aria-hidden="true"></ArrowRightIcon>
        </div>
        <div class="mr-2">
            <div v-if="!editMode">
                {{ this.code.title }}
            </div>
            <div v-if="editMode">
                <input type="text" v-model="titleValue">
            </div>
        </div>
        <div class="cursor-pointer" @click="toEditMode" v-if="!editMode">
            <PencilIcon class="h-5 w-5" aria-hidden="true"></PencilIcon>
        </div>
        <div class="cursor-pointer" v-if="editMode">
           <v-button title="Сохранить" :loading="loading" @click="saveTitle"></v-button>
        </div>
    </div>
</template>

<script>
import {ArrowRightIcon, PencilIcon} from '@heroicons/vue/24/outline'
import {mapActions, mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";

export default {
    components: {
        ArrowRightIcon,
        PencilIcon
    },
    data() {
        return {
            editMode: false,
            titleValue: '',
            loading: false
        }
    },
    computed: {
        ...mapState(qrCodeFormStore, ["code"])
    },
    methods: {
        ...mapActions(qrCodeFormStore, ["updateCode", "saveCode"]),

        toEditMode() {
            this.titleValue = this.code.title
            this.editMode = true
        },

        async saveTitle() {
            this.loading = true
            this.updateCode({title: this.titleValue})
            await this.saveCode()
            this.editMode = false
            this.loading = false
        }
    }
}
</script>

